import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilters } from '@views/AssetsCoverage/assets.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/')({
  validateSearch: zodValidator(withDefaults(schema.ASSET_COVERAGE, defaultFilters)),
  search: {
    middlewares: [stripSearchParams(defaultFilters)],
  },
});
